<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { Assignment } from '../Assignment';
    import ProgressBarAnalytics from '../../../shared/ProgressBarAnalytics.svelte';

    export let assignment: Assignment;
</script>

<div
    style="display: flex; align-items: center; justify-content: center; font-size: 9px; column-gap: 5px; color: #8b8b8b;"
>
    <div>{$_('optimizing')}</div>
    <ProgressBarAnalytics
        currentValue={assignment.getRouteCalculationProgressAsNumber()}
        totalValue={100}
        color="#8b8b8b"
        displayMode="simple"
    />
</div>
